import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import SwalComponent from './../../utils/custom-swal.component';
import { HandleFileService } from './../../api/handle-file.service';
import { FormService } from './../../api/form.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../api.service';
import { DataObject } from '../../interfaces/data-objects';
import { TransactionTypes } from '../../models/transactions-enum';

@Component({
  selector: 'iv-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Input() propertyExists: boolean;
  @Input() transactionType = undefined;
  @Input() transaction: DataObject = {};
  @Output() saveDSF;
  @Output() fileChanged = new EventEmitter();
  @Output() downloadTemplate = new EventEmitter();
  @ViewChild('warnAlert', { static: true }) private warnAlert: SwalComponent;
  @ViewChild('badFileAlert', { static: true }) private badFileAlert: SwalComponent;

  file = File;
  fileList = FileList;
  csvTemplate: string;
  xlsxTemplate: string;
  dsfxlsxTemplate: string;
  dsfPropertyForm: any;
  swalWarnOptions: any;
  swalBadFileOptions: any;
  dsfPropertyFormChanges$: Subscription;

  constructor(
    private handleFileService: HandleFileService,
    private formService: FormService,
    private api: ApiService) {
    this.saveDSF = new EventEmitter<any>();
    this.swalWarnOptions = this.getSwalOptions('warnAlert');
    this.swalBadFileOptions = this.getSwalOptions('badFileAlert');
  }

  ngOnInit() {
    this.xlsxTemplate = this.getXlsxTemplate(this.transaction);
    this.csvTemplate = this.api.getPortwithURL('/static/properties/property-upload.csv');
    this.dsfxlsxTemplate = this.api.getPortwithURL('/static/properties/property-upload DSF.xlsm');
  }

  getXlsxTemplate(transaction: DataObject): string {
    let fileName = 'property-upload';
    if (transaction && transaction.transaction_type === TransactionTypes.VALUATION) {
      const valuationFileName = `${TransactionTypes.VALUATION}`.toPascalCase();
      if (valuationFileName) {
        fileName = `property-upload-${valuationFileName}`;
      }
    }
    return this.api.getPortwithURL(`/static/properties/${fileName}.xlsm`);
  }

  triggerUpload() {
    document.getElementById('file-upload')?.click();
  }

  selectTemplateCSV() {
    const templateType = 'csv';
    this.downloadTemplate.emit(templateType);
  }

  selectTemplateXLSX() {
    const templateType = 'xlsx';
    this.downloadTemplate.emit(templateType);
  }

  checkFileType(file) {
    const fileType = this.handleFileService.getFileType(file);
    if (fileType === 'text/csv' ||
      fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      fileType === 'application/vnd.ms-excel.sheet.macroenabled.12' ||
      fileType === 'application/vnd.ms-excel.sheet.macroEnabled.12') {
      return true;
    }
    return false;
  }

  fileChange(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.file = this.fileList[0];
      if (this.checkFileType(this.file)) {
        if (this.propertyExists) {
          this.showWarnAlert(this.file);
        } else {
          this.fileChanged.emit(this.file);
        }
      } else {
        this.showBadFileType();
      }
    }
    // Handle duplicate uploads
    event.target.value = null;
  }

  showWarnAlert(file) {
    this.warnAlert.fire()
      .then(response => {
        if (response.value) {
          this.fileChanged.emit(file);
        }
      });
  }

  showBadFileType() {
    this.badFileAlert.fire();
  }

  radioSelected(value) {
    this.transaction.involved_in_consultation = (value === true || value === 'true');
    this.saveDSF.emit({ involved_in_consultation: this.transaction.involved_in_consultation });
  }
  disableInvolvedinConsultation() {
    let disabled = false;
    switch (this.transaction.dsf_transaction_type) {
      case 'origination':
      case 'trail':
        disabled = true;
        break;
      default: break;
    }
    return disabled;
  }
  showInvolvedinConsultation() {
    return (this.transactionType === 'dsf' && this.transactionType !== undefined);
  }
  hideOptions() {
    return (this.transactionType === 'dsf' && this.transaction.involved_in_consultation);
  }
  getSwalOptions(alertName) {
    switch (alertName) {
      case 'warnAlert':
        const optionsAlert = {
          showConfirmButton: true,
          showCloseButton: true,
          confirmButtonText: 'Upload',
          cancelButtonText: 'Cancel',
          showCancelButton: true
        };
        return this.formService.getSwalOptions(optionsAlert);
      case 'badFileAlert':
        const options = {
          showConfirmButton: false,
          showCloseButton: true,
          confirmButtonText: 'Upload',
          cancelButtonText: 'Cancel',
          showCancelButton: true
        };
        return this.formService.getSwalOptions(options);
    }
  }

}
